<template>
  
    <div class="WordSection1" >
      <p class="MsoNormal" style="text-align:center">
      <span lang="EN-US" style='font-size:18.0pt;font-family:"Arial",sans-serif'
        >GF-2 Satellite</span
      >
    </p>
      <hr class="divider" />
      <p class="MsoNormal" align="center" style="text-align:center">
        <span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"Arial",sans-serif;mso-no-proof:yes'
          ><img
            width="441"
            height="264"
            src="../../assets/gf2sat.png"
            alt="GF2"
            v:shapes="图片_x0020_1"
          /></span
        ><span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"Arial",sans-serif'
          ><o:p></o:p
        ></span>
      </p>

      <p
        class="MsoNormal mt-4"
        style="text-indent:21.0pt;mso-char-indent-count:2.0;
mso-pagination:widow-orphan"
      >
        <span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;
font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
          >GF-2 satellite was successfully launched on August 19, 2014. It is
          the first civil optical satellite with spatial resolution better than
          1 meter autonomously developed by China. The leading user of GF-2 is
          Ministry of Natural Resources of China. Other users include Ministry
          of Housing and Urban-Rural Development, Ministry of Transport, the
          State Forestry and Grassland Administration, etc. The satellite is
          equipped with two high resolution 1-meter panchromatic and 4-meter
          multispectral cameras to achieve imaging mosaic.<o:p></o:p
        ></span>
      </p>

      <p
        class="MsoNormal"
        style="text-indent:21.0pt;mso-char-indent-count:2.0;
mso-pagination:widow-orphan"
      >
        <span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;
font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
          >As the first wide-swath civilian satellite with sub-meter resolution
          in China, GF-2 satellite has many innovations in design, breaking
          through the sub-meter level and wide-swath imaging technology.
          Optimized design of wide coverage and quick re-visit orbit can make
          the site re-visit period in any region of the world less than 5 days
          with side swing (±23°). In the case of side swing (±35°), the revisit
          period will be further shortened; the highly stable and fast attitude
          side swing maneuver control technology achieves 35° stability within
          150 seconds; the positioning accuracy without control points achieves
          20-35m, and it also has onboard intelligent management capability. The
          spatial resolution of GF-2 satellite image can reach 0.8 meters, which
          indicates that China's satellites has entered a sub-meter era.<span
            style="mso-spacerun:yes"
            >&nbsp; </span
          ><o:p></o:p
        ></span>
      </p>

      <span
        lang="EN-US"
        style='font-size:10.5pt;font-family:"Arial",sans-serif;
mso-fareast-font-family:宋体;mso-font-kerning:0pt;mso-ansi-language:EN-US;
mso-fareast-language:ZH-CN;mso-bidi-language:AR'
        ><br clear="all" style="page-break-before:always" />
      </span>

      <p class="MsoNormal" style="mso-pagination:widow-orphan;text-align:center;">
        <b
          ><span
            lang="EN-US"
            style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
0pt;mso-bidi-language:AR'
            >Orbit parameters<o:p></o:p></span
        ></b>
      </p>

     
      <table
        class="MsoTableGrid"
        border="1"
        cellspacing="0"
        cellpadding="0"
        align="left"
        style="border-collapse:collapse;border:none;width:100%"
      >
        <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
          <td
            width="208"
            valign="top"
            style="width:155.8pt;border:solid windowtext 1.0pt;
  mso-border-alt:solid windowtext .5pt;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <b
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >Item</span
                ></b
              ><span
                lang="EN-US"
                style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                ><o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="682"
            valign="top"
            style="width:511.25pt;border:solid windowtext 1.0pt;
  border-left:none;mso-border-left-alt:solid windowtext .5pt;mso-border-alt:
  solid windowtext .5pt;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <b
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >Parameter</span
                ></b
              ><span
                lang="EN-US"
                style='font-size:12.0pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt'
                ><o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:1">
          <td
            width="208"
            style="width:155.8pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >Orbit<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="682"
            valign="top"
            style="width:511.25pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >Sun-synchronous orbit<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:2">
          <td
            width="208"
            style="width:155.8pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >Orbit altitude<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="682"
            valign="top"
            style="width:511.25pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >631 km<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:3">
          <td
            width="208"
            style="width:155.8pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >Orbit inclination<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="682"
            valign="top"
            style="width:511.25pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >97.9080°<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:4">
          <td
            width="208"
            style="width:155.8pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >Local time of descending node<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="682"
            valign="top"
            style="width:511.25pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >10:30 am<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:5;mso-yfti-lastrow:yes">
          <td
            width="208"
            style="width:155.8pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >Side swing capability (rolling) <o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="682"
            valign="top"
            style="width:511.25pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              style="mso-pagination:widow-orphan;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                >±35&ordm;, 35°maneuvering time ≤180s<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
      </table>


      <p class="MsoNormal" style="mso-pagination:widow-orphan">
        <b
          ><span
            lang="EN-US"
            style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
0pt;mso-bidi-language:AR'
            ><o:p>&nbsp;</o:p></span
          ></b
        >
      </p>

      <p class="MsoNormal mt-5" style="mso-pagination:widow-orphan;text-align:center">
        <b
          ><span
            lang="EN-US"
            style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
0pt;mso-bidi-language:AR'
            >Sensor technical parameters<o:p></o:p></span
        ></b>
      </p>

      <table
        class="MsoTableGrid"
        border="1"
        cellspacing="0"
        cellpadding="0"
        align="left"
        style="border-collapse:collapse;border:none;width:100%"
      >
        <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
          <td
            width="243"
            style="width:182.4pt;border:solid windowtext 1.0pt;mso-border-alt:
  solid windowtext .5pt;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <b
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  >Parameter<o:p></o:p></span
              ></b>
            </p>
          </td>
          <td
            width="646"
            colspan="2"
            style="width:484.55pt;border:solid windowtext 1.0pt;
  border-left:none;mso-border-left-alt:solid windowtext .5pt;mso-border-alt:
  solid windowtext .5pt;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-element:frame;
  mso-element-frame-hspace:9.0pt;mso-element-wrap:around;mso-element-anchor-vertical:
  paragraph;mso-element-anchor-horizontal:margin;mso-element-top:15.3pt;
  mso-height-rule:exactly"
            >
              <b
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >Panchromatic/Multispectral (P/MS) camera</span
                ></b
              ><b
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p></span
              ></b>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:1">
          <td
            width="243"
            rowspan="5"
            style="width:182.4pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Spectral band<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="144"
            style="width:108.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Panchromatic image<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="502"
            style="width:376.55pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >0.45</span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;mso-font-kerning:0pt;mso-bidi-language:AR"
                >～</span
              ><span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                >0.90 <span class="SpellE">μm</span><o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:2">
          <td
            width="144"
            rowspan="4"
            style="width:108.0pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Multispectral Image<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="502"
            style="width:376.55pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >0.45</span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;mso-font-kerning:0pt;mso-bidi-language:AR"
                >～</span
              ><span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                >0.52 <span class="SpellE">μm</span><o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:3;height:4.5pt">
          <td
            width="502"
            style="width:376.55pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt;height:4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >0.52</span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;mso-font-kerning:0pt;mso-bidi-language:AR"
                >～</span
              ><span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                >0.59 <span class="SpellE">μm</span><o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:4">
          <td
            width="502"
            style="width:376.55pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >0.63</span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;mso-font-kerning:0pt;mso-bidi-language:AR"
                >～</span
              ><span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                >0.69 <span class="SpellE">μm</span><o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:5">
          <td
            width="502"
            style="width:376.55pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >0.77</span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;mso-font-kerning:0pt;mso-bidi-language:AR"
                >～</span
              ><span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                >0.89 <span class="SpellE">μm</span><o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:6">
          <td
            width="243"
            rowspan="2"
            style="width:182.4pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >GSD<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="144"
            style="width:108.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Panchromatic image<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="502"
            style="width:376.55pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >0.8 m<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:7">
          <td
            width="144"
            style="width:108.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Multispectral Image<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="502"
            style="width:376.55pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >3.2 m<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:8;height:11.3pt">
          <td
            width="243"
            style="width:182.4pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Swath width<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="646"
            colspan="2"
            style="width:484.55pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >45 <span class="GramE">km(</span>Combining two cameras’
                observation)<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:9;height:11.3pt">
          <td
            width="243"
            style="width:182.4pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Site re-visit period with side swing<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="646"
            colspan="2"
            style="width:484.55pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >5 days<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:10;mso-yfti-lastrow:yes;height:11.3pt">
          <td
            width="243"
            style="width:182.4pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >Site re-visit period without side swing<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="646"
            colspan="2"
            style="width:484.55pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:15.3pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                >69 days<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
      </table>

      <b
        ><span
          lang="EN-US"
          style='font-size:10.5pt;font-family:"Arial",sans-serif;
mso-fareast-font-family:宋体;mso-font-kerning:0pt;mso-ansi-language:EN-US;
mso-fareast-language:ZH-CN;mso-bidi-language:AR'
          ><br
            clear="all"
            style="mso-special-character:line-break;page-break-before:always"
          /> </span
      ></b>

      <p class="MsoNormal" align="center" style="text-align:center">
        <b
          ><span
            lang="EN-US"
            style='font-size:12.0pt;font-family:"Arial",sans-serif'
            ><o:p>&nbsp;</o:p></span
          ></b
        >
      </p>

     
    </div>
  
</template>


<style scoped>
.MsoNormal {
  text-align: left;
}
</style>